import { Injectable } from '@angular/core';
import { FamilleModel } from '../famille/models/famille.model';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { FactureModel } from '../facture/models/facture.model';
import { PaiementModel } from '../paiement/models/paiement.model';



@Injectable()
export class CalculMontantService {


    private totalPaiement: BehaviorSubject<string>;
    private totalFacture: BehaviorSubject<string>;
    private resteFacture: BehaviorSubject<string>;

    private _totalPaiement: number;
    private _totalFacture: number;

    constructor() {
        this.totalPaiement = new BehaviorSubject<string>(null);
        this.totalFacture = new BehaviorSubject<string>(null);
        this.resteFacture = new BehaviorSubject<string>(null);

    }

    updateValues(data: {paiements?: PaiementModel[], factures?: FactureModel[]}) {

        let totalPaiement: number = null;
        let totalFacture: number = null;
        let resteFacture: number = null;

        if (data.paiements instanceof Array) {

            totalPaiement = data.paiements.reduce((acc: number, curr) => {
                const montant: number = curr.montantPaiement ? +curr.montantPaiement : 0;
                // const somme: number = curr.isRemboursement ? + acc - montant : + acc + montant;
                const somme: number = + acc + montant; // le montant d'un remboursement est déjà négatif
                return somme;
            }, 0);
            console.log({totalPaiement});
            this._totalPaiement = totalPaiement;
            this.totalPaiement.next((+totalPaiement).toFixed(2));

        } else if (data.factures instanceof Array) {
            totalFacture = data.factures.reduce((acc, curr) => {
                return acc + (curr.montantTotal ? curr.montantTotal : 0); // parseFloat(curr.montantTotal ? curr.montantTotal : 0);
            }, 0);
            this._totalFacture = totalFacture;
            this.totalFacture.next((+totalFacture).toFixed(2));

        }

        if (this._totalPaiement != null && this._totalFacture != null) {
            // resteFacture = parseFloat(this._totalFacture) - parseFloat(this._totalPaiement);
            resteFacture = this._totalFacture - this._totalPaiement;
            this.resteFacture.next(resteFacture.toFixed(2));
        }

    }

    getTotalPaiement(): Observable<string> {
        return this.totalPaiement;
    }

    getTotalFacture(): Observable<string> {
        return this.totalFacture;
    }

    getResteFacture(): Observable<string> {
        return this.resteFacture;
    }

}



// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/shared/services/calcul-montant.service.ts